import { render, staticRenderFns } from "./EditorImageDialog.vue?vue&type=template&id=1d65b442&scoped=true"
import script from "./EditorImageDialog.vue?vue&type=script&lang=js"
export * from "./EditorImageDialog.vue?vue&type=script&lang=js"
import style0 from "./EditorImageDialog.vue?vue&type=style&index=0&id=1d65b442&prod&lang=css"
import style1 from "./EditorImageDialog.vue?vue&type=style&index=1&id=1d65b442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d65b442",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VDivider,VIcon,VOverlay,VRow})
